import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../shared/shared.module';

import { EditorListComponent } from './editor-list/editor-list.component';
import { ReportEditorComponent } from './report-editor/report-editor.component';
import { ViewEditorComponent } from './view-editor/view-editor.component';
import { FieldEditorComponent } from './field-editor/field-editor.component';
import { FilterEditorComponent } from './filter-editor/filter-editor.component';
import { ReportFilterEditorComponent } from './report-filter-editor/report-filter-editor.component';
import { KeyValueEditorComponent } from './key-value-editor/key-value-editor.component';
import { ChartEditorComponent } from './chart-editor/chart-editor.component';

@NgModule({
  declarations: [
    EditorListComponent,
    ReportEditorComponent,
    ViewEditorComponent,
    FieldEditorComponent,
    FilterEditorComponent,
    ReportFilterEditorComponent,
    KeyValueEditorComponent,
    ChartEditorComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule
  ]
})
export class EditorModule { }
